module.exports = __webpack_public_path__ + "img/2.69c362c3.jpg";